(function () {
  function initCarousel(container) {
    if (container.dataset.ctsInitialized === 'true') return;
    if (container.dataset.slider !== 'true') return;
    if (typeof Flickity === 'undefined') return;

    var slider = container.querySelector('.cts-slider');
    if (!slider) return;

    var autoplay = container.dataset.autoplay === 'true';
    var speed = parseInt(container.dataset.speed, 10) || 5000;
    var arrows = container.dataset.arrows === 'true';

    container.dataset.ctsInitialized = 'true';

    container.flickityInstance = new Flickity(slider, {
      cellSelector: '.cts-slide',
      contain: true,
      wrapAround: true,
      pageDots: false,
      prevNextButtons: false,
      adaptiveHeight: false,
      autoPlay: autoplay ? speed : false,
      pauseAutoPlayOnHover: true,
      dragThreshold: 10
    });

    if (arrows) {
      var prevBtn = container.querySelector('.cts-arrow--prev');
      var nextBtn = container.querySelector('.cts-arrow--next');

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          container.flickityInstance.previous();
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          container.flickityInstance.next();
        });
      }
    }
  }

  function destroyCarousel(container) {
    if (container.flickityInstance) {
      container.flickityInstance.destroy();
      container.flickityInstance = null;
    }
    container.dataset.ctsInitialized = 'false';
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.custom-testimonial').forEach(initCarousel);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll();
  });

  document.addEventListener('shopify:section:load', function (evt) {
    initAll(evt.target);
  });

  document.addEventListener('shopify:section:unload', function (evt) {
    var container = evt.target.querySelector('.custom-testimonial');
    if (container) destroyCarousel(container);
  });
})();
